const DASHBOARD_API = {
    SOURCE: 'web',
    SOURCE_APP: 'haowhoo',
    auth: {
        customerQuery: '/auth/customer/query',
    },
    tenantApiKey: {
        list: '/auth/tenantApiKey/list',
        create: '/auth/tenantApiKey/create',
        revoke: (id: number) => `/auth/tenantApiKey/revoke/${id}`,
    },
    materials: {
        info: '/mainD/material/materialInfo',
        dirTree: '/mainD/material/dir/tree',
        dirEdit: '/mainD/material/dir/createOrModify',
        dirDelete: '/mainD/material/dir/delete',
        count: '/mainD/material/count',
        list: '/mainD/material/list',
        create: '/mainD/material/createList',
        edit: '/mainD/material/modify',
        delete: '/mainD/material/delete',
        move: '/mainD/material/move',
        download: '/fs/materialDownloadForDashboard/getFileUrl',
        videoPlay: (itemId: string) => `/fs/materialDownloadForDashboard/playVod/${itemId}`,
        audioPlay: (itemId: string) => `/fs/materialDownloadForDashboard/originalVod/${itemId}`,
        uploadVodPrepare: '/fs/materialUpload/vodPrepare',
        vodSignature: '/fs/materialUpload/vodSignature',
        vodProcess: '/fs/materialUpload/vodProcess',
        uploadFilePrepare: (materialType: string) => `/fs/materialUpload/largeFilePrepare/${materialType}`,
    },
};

export default DASHBOARD_API;
